import React from "react";

import {
  Facebook,
  Instagram,
  Linkedin,
  Twitter,
  ArrowUp,
} from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#1b1b1b] text-white">
      {/* Top Footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-16 py-20 grid gap-12 md:grid-cols-4">
        
        {/* Brand */}
        <div>
          <div className="flex items-center gap-3 mb-6">
            <img
              src="/logo.png"
              alt="Veda Creation & Group"
              className="h-20 md:h-24 lg:h-28 w-auto object-contain"
            />

            <div>
              <h3 className="font-serif text-lg">Veda Creation</h3>
              <p className="text-xs text-[#C9A962] tracking-widest">
                & GROUP
              </p>
            </div>
          </div>

          <p className="text-white/60 text-sm leading-relaxed mb-6">
            Transforming spaces into extraordinary experiences. From
            concept to completion, we bring your vision to life.
          </p>

          <div className="flex gap-3">
            {[Instagram, Facebook, Linkedin, Twitter].map((Icon, i) => (
              <a
                key={i}
                href="#"
                className="w-9 h-9 border border-white/20 flex items-center justify-center hover:bg-[#C9A962] hover:border-[#C9A962] transition"
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        {/* Services */}
        <div>
          <h4 className="font-serif text-lg mb-6">Our Services</h4>
          <ul className="space-y-3 text-sm text-white/60">
            <li>2D Layouts & Floor Plans</li>
            <li>3D Visualization</li>
            <li>Electrical Design</li>
            <li>Plumbing Solutions</li>
            <li>False Ceiling Design</li>
            <li>Furniture Planning</li>
          </ul>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="font-serif text-lg mb-6">Quick Links</h4>
          <ul className="space-y-3 text-sm text-white/60">
            <li>About Us</li>
            <li>Portfolio</li>
            <li>Testimonials</li>
            <li>Contact</li>
            <li>Privacy Policy</li>
            <li>Terms of Service</li>
          </ul>
        </div>

        {/* Newsletter */}
        <div>
          <h4 className="font-serif text-lg mb-6">Newsletter</h4>
          <p className="text-sm text-white/60 mb-4">
            Subscribe for design inspiration and exclusive offers.
          </p>

          <input
            type="email"
            placeholder="Your email address"
            className="w-full bg-transparent border border-white/20 px-4 py-3 text-sm mb-4 focus:outline-none focus:border-[#C9A962]"
          />

          <button className="w-full bg-[#C9A962] text-black py-3 text-sm font-medium hover:bg-[#b8954f] transition">
            Subscribe
          </button>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-16 py-6 flex items-center justify-between text-sm text-white/50">
          <p>© 2026 Veda Creation & Group. All rights reserved.</p>

          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="w-10 h-10 bg-[#C9A962] flex items-center justify-center text-black hover:bg-[#b8954f] transition"
          >
            <ArrowUp className="w-4 h-4" />
          </button>
        </div>
      </div>
    </footer>
  );
}
